<template>
  <page>
    <v-card>
      <v-toolbar v-if="mode === 'review'" dense color="grey lighten-3" flat>
        <v-icon>mdi-pencil</v-icon>
        <v-toolbar-title>Edit Claims Status </v-toolbar-title>
      </v-toolbar>
      <v-toolbar v-if="mode === 'new'" dense color="grey lighten-3" flat>
        <v-icon>mdi-plus</v-icon>
        <v-toolbar-title>Create Claims Status</v-toolbar-title>
      </v-toolbar>
      <v-toolbar v-if="mode === 'query'" dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Query Claims Status </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <message :messages="messages"></message>
        <v-container fluid grid-list-lg>
          <v-layout wrap>
            <v-flex xs6 v-if="mode === 'new'">
              <v-text-field
                :label="labels.claimStatus"
                v-model="clmStatForm.claimStatus"
                :error-messages="errors.collect('claimStatus')"
                data-vv-name="claimStatus"
                :data-vv-as="labels.claimStatus"
                v-validate="'required|param|max:1'"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.claimStatus }}</v-subheader>
              <div class="queryValue">{{ clmStatForm.claimStatus }}</div>
            </v-flex>
            <v-flex xs6 v-if="mode !== 'query'">
              <v-text-field
                :label="labels.claimStatusDesc"
                v-model="clmStatForm.claimStatusDesc"
                :error-messages="errors.collect('claimStatusDesc')"
                data-vv-name="claimStatusDesc"
                :data-vv-as="labels.claimStatusDesc"
                v-validate="'required|max:20'"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.claimStatusDesc }}</v-subheader>
              <div class="queryValue">{{ clmStatForm.claimStatusDesc }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ clmStatForm.createdBy }}</div>
            </v-flex>
            <v-flex xs6 v-if="mode !== 'new'">
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ clmStatForm.createdDate }}</div>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ formatDisplayDate(clmStatForm.createdDate) }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="mode !== 'new'">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ clmStatForm.modifiedBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ clmStatForm.modifiedDate }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-btn color="red" dark class=" mr-2" @click="doReturn" :loading="loading">
        Cancel
        <v-icon right>mdi-cancel</v-icon>
      </v-btn>
      <v-btn v-if="mode !== 'query'" color="primary" dark class=" mr-2" @click="doSave" :loading="loading">
        Save
        <v-icon right>mdi-content-save</v-icon>
      </v-btn>
      <v-spacer class="mt-2"></v-spacer>
      <template v-if="mode !== 'new'">
        <v-divider></v-divider>
        <ClmStatCause :clmStat="clmStatForm.claimStatus" :clmStatDesc="clmStatForm.claimStatusDesc"></ClmStatCause>
      </template>
    </v-card>
  </page>
</template>
<script>
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import ClmStatCause from '../clmStatCause/ClmStatCause'

export default {
  data() {
    return {
      labels: {
        claimStatus: 'Status',
        claimStatusDesc: 'Description',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      showClmStatCause: false,
      clmStat: undefined,
      mode: undefined,
      loading: false,
      clmStatForm: {
        claimStatus: undefined,
        claimStatusDesc: undefined,
        createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        createdDate: new Date(),
        modifiedBy: undefined,
        modifiedDate: undefined
      }
    }
  },
  mounted() {
    this.clmStat = this.$route.params.clmStat
    this.mode = this.$route.params.mode
    this.init()
  },
  computed: {
    menu() {
      return this.$store.state.claimStatusParam.menu
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    init() {
      this.resetValidator()
      this.resetMessages()
      if (this.clmStat && this.mode !== 'new') {
        const clmStat = this.clmStat
        const apiURI = this.menu.claimStatus
        if (apiURI) {
          this.loading = true
          this.$http
            .get(expandURI(apiURI, { claimStatus: clmStat }))
            .then((result) => {
              const { data } = result.data
              if (data) {
                this.clmStatForm.claimStatus = data.claimStatus.claimStatus
                this.clmStatForm.claimStatusDesc = data.claimStatus.claimStatusDesc
                this.clmStatForm.createdBy = data.createdBy
                this.clmStatForm.createdDate = formatDisplayDate(data.createdDate)
                this.clmStatForm.modifiedBy = data.modifiedBy
                this.clmStatForm.modifiedDate = formatDisplayDate(data.modifiedDate)
                this.goClmStatCause()
              }
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
          this.loading = false
        }
      } else {
        this.mode = 'new'
        this.clmStatForm.claimStatus = undefined
        this.clmStatForm.claimStatusDesc = undefined
        this.clmStatForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.clmStatForm.createdDate = new Date()
        this.clmStatForm.modifiedBy = undefined
        this.clmStatForm.modifiedDate = undefined
      }
    },
    goClmStatCause() {
      const clmStatData = {
        claimStatus: this.clmStatForm.claimStatus,
        claimStatusDesc: this.clmStatForm.claimStatusDesc,
        claimStatusMode: this.mode
      }
      this.$store.commit('CLAIMSTATUS_COMMIT_KEY', clmStatData)
    },
    doReturn() {
      this.$router.push({ name: 'clmStat' })
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.mode === 'new') {
            this.doCreate()
          } else if (this.mode === 'review') {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCreate() {
      const apiURI = this.menu.createClaimStatus
      if (apiURI) {
        this.$http
          .post(apiURI, this.clmStatForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.clmStat = this.clmStatForm.claimStatus
              this.mode = 'review'
              this.init()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doUpdate() {
      const apiURI = this.menu.updateClaimStatus
      if (apiURI) {
        this.$http
          .put(apiURI, this.clmStatForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doReturn()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [MessageMixin],
  components: {
    ClmStatCause
  }
}
</script>
